import React from 'react';
import './bookings.css'
import Search from '../components/common/search';
import Nav from '../components/layout/nav';
import BookingsTable from '../components/common/bookingstable';



const Bookings = () => {
    return ( <>
         <div className='dashboard'>

            <Nav />

            <div className='mainarea'>

                <div className='navtoppart'>

                    <div className='welcomebcakdiv'>
                        <h6 className='welcomebacktext'>Welcome back</h6>
                        <h6 className='admintitle'>Admin Dashboard</h6>
                    </div>

                    <div className='profileandnotidiv'>
                        <div className='notidiv'>
                            <div className='notiicon'></div>
                        </div>
                        <div className='profilediv'></div>
                    </div>

                </div>
                <div className='pagecenter'>

                    <div className='homecontainer'>

                        <section>
                            <div className='titlediv2'>
                                     <div className='titlediv'>
                                            <h1>Bookings</h1>
                                            <h2>Manage event bookings and tickets</h2>
                                        </div>
                                        <button className='exportbtn'>
                                            <div className='exporticon'></div>
                                            <h6 className='btntext'>Export</h6>
                                        </button>
                            </div>
                           <Search 
                           search='Search booking....'/>
                        
                               <BookingsTable />

                           
                        </section>
                            
                    </div>
                        
                </div>
                
               
            </div>

        </div>
    </> );
}
 
export default Bookings;